import styled from 'styled-components'
import { Form, Row, Button, Container } from 'react-bootstrap'
import colorConfig from '../../colorConfig'

const YellowRoundedContainer = styled(Container)`
    background-color: ${colorConfig.krem};  
    color: black;
    border-bottom: 0px;  
    padding: 20px 0px 20px 0px;      
    border: 0px solid black;
    border-radius: 0.5em;
    font-family: "RM Neue", "sans-serif";
    font-size: 20px !important; 

    input {   
        padding: 20;
        font-family: "RM Neue", "sans-serif";
        font-size: 20px !important; 
        border-radius: 0.5em;
        border: 0px solid black;  

        *:focus {
           outline: none; !important; 
        }
    }

    .form-control {
        border-radius: 0.5em; !important; 
    }

    .form-control:focus {
        border-color: inherit;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 0.5em;
    }

    .alert-danger {
        color: ${colorConfig.tabell_lysGul}; !important; 
        background-color: ${colorConfig.danger_bg};
        border-color: none;
        font-family: "RM Neue", "sans-serif";
        font-size: 20px !important; 
        border-radius: 0.5em;
        font-weight: 400;
    }
}
`


const BlueRow = styled(Row)`    
    //background-color: rgba(195, 215, 238, 0.4);
    background-color: ${colorConfig.tabell_lysGul};  
    color: black;
    border-bottom: 0px;  
    padding: 28px 10px 28px 10px;      
    border: 0px solid black;
    font-family: "RM Neue", "sans-serif";
    font-size: 20px !important; 
    min-width: 1800px;
`

const BfRowForm = styled(Row)`
    background-color: ${colorConfig.tabell_lysGul};  
    color: black;
    border-bottom: 0px;  
    padding: 10px 30px 0px 30px;      
    border: 0px solid black;
    font-family: "RM Neue", "sans-serif";
    font-size: 20px !important;
`

const BfYellowRowForm = styled(Row)`
    background-color: ${colorConfig.krem};  
    color: black;
    border-bottom: 0px;  
    padding: 10px 30px 0px 30px;      
    border: 0px solid black;
    font-family: "RM Neue", "sans-serif";
    font-size: 20px !important; 
`

const BfTightRowForm = styled(Row)`        
    background-color: ${colorConfig.tabell_lysGul};  
    padding: 15px 30px 0px 30px;    
    color: black;
    border-bottom: 0px;     
    border: 0px solid black;
    font-family: "RM Neue", "sans-serif";
    font-size: 20px !important; 
`

const BfTightYellowRowForm = styled(Row)`        
    background-color: ${colorConfig.krem};  
    padding: 15px 30px 0px 30px;    
    color: black;
    border-bottom: 0px;     
    border: 0px solid black;
    font-family: "RM Neue", "sans-serif";
    font-size: 20px !important; 
`

const BfRowSpacer = styled(Row)`    
    background-color: white;
    height: 40px;
`    

const BfFormLabel = styled(Form.Label)`
        font-family: "RM Neue", "sans-serif";
        font-weight: 400;
        font-size: 20px;
        color: black;
        margin-bottom: 0px;       
    `
const BfFormLabelSm = styled.span`
        font-family: "RM Neue", "sans-serif";
        font-size: 14px;
        font-weight: 400;
        color: black;
        margin-top: 4px;    
    `
const BfFormErrorSm = styled.span`
        font-family: "RM Neue", "sans-serif";
        font-size: 14px;
        font-weight: 700;
        color: ${colorConfig.danger_bg};
        margin-top: 4px;    
    `

const BfFormControl = styled(Form.Control)`    
  font-size: 20px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;      
`

const BfFormCheck = styled(({ checked, ...rest }) => <Form.Check {...rest} />)`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  font-size: 20px;
  padding: 6px 12px 6px 12px;
  border-radius: 0.5em;
  margin-left: 0rem;
  border: 1.5px solid ${props => props.checked ? colorConfig.button_focused : colorConfig.tabellrad_tekst};
  background-color: ${props => props.checked ? colorConfig.button_focused || '#00aaff' : 'transparent'};
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;

  .form-check-input {
    width: 1.2em;
    height: 1.2em;
    margin: 0;
    cursor: pointer;
    border: 1px solid ${props => props.checked ? colorConfig.button_focused : colorConfig.tabellrad_tekst};
  }

  .form-check-label {
    margin-left: 0.5em;
    font-weight: 500;
    cursor: pointer;
    color: ${props => props.checked ? '#fff' : '#000'};
  }

  &.form-check-inline {
    margin-right: 1rem;
    cursor: pointer;
  }

  .form-check-input:checked {
    background-color: ${colorConfig.button_focused};
    border: 2px solid white;
    cursor: pointer;
  }
`;



const BfButtonSquare = styled(Button)`
    border-radius: 0.5em;
    font-family: "RM Neue", "sans-serif";
    font-size: 30px;
    border: 0px;
    background-color: ${colorConfig.button_bg};
    color: black;
    font-weight: 700;        
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2), 0 2px 4px 0 rgba(0,0,0,0.19); 

    &&:hover {
        background-color: ${colorConfig.button_focused};
        -webkit-transition: background-color 1.5s ease-out;
        -moz-transition: background-color 1.5s ease-out;
        -o-transition: background-color 1.5s ease-out;
        transition: background-color 1.5s ease-out;
        transition-delay:0.1s;
    }
    &&:focus {
        background-color: ${colorConfig.button_focused};
    }
    &&:disabled {
        background-color: gray;

    }
`

const BfButtonBlueNarrow = styled(Button)`
        border-radius: 0.5em;
        font-family: "RM Neue", "sans-serif";
        font-size: 20px;
        border: 0px;
        background-color: ${colorConfig.button_bg};
        color: black;
        padding: 4px 20px 4px 20px;
        font-weight: 400;         

        &&:hover {
            background-color: ${colorConfig.button_focused};
            color: black;
        }
        &&:focus {
            background-color: ${colorConfig.button_focused};
        }
        &&:disabled {
            background-color: gray;
        }
`

const BfButtonBlueNarrowSecondary = styled(Button)`
      border-radius: 0.5em;
      font-family: "RM Neue", "sans-serif";
      font-size: 20px;
      border: 2px;
      background-color: transparent !important;
      color: black;
      border-style: solid;
      border-color: ${colorConfig.button_bg};
      padding: 4px 20px 4px 20px;
      font-weight: 400;         

      &&:hover {
          background-color: transparent;
          color: ${colorConfig.button_focused};
          border-color: ${colorConfig.button_focused};
          -webkit-transition: border-color 1.5s ease-out;
          -moz-transition: border-color 1.5s ease-out;
          -o-transition: border-color 1.5s ease-out;
          transition: border-color 1.5s ease-out;
          transition-delay:0.1s;
      }
      &&:focus {
          background-color: transparent;
          color: ${colorConfig.button_focused};
          border-color: ${colorConfig.button_focused};
      }
      &&:disabled {
          border-color: gray;
      }
`

const DeactivateButtonNarrow = styled(Button)`
  background-color: #dc143c;
  color: white;
  border-radius: 0.5em;
  font-family: "RM Neue", "sans-serif";
  font-size: 20px;
  border: 0px; 
  padding: 4px 20px 4px 20px; 
  font-weight: 400;         

  &:hover {
    background-color: rgb(148, 12, 42);
    -webkit-transition: background-color 1.5s ease-out;
    -moz-transition: background-color 1.5s ease-out;
    -o-transition: background-color 1.5s ease-out;
    transition: background-color 1.5s ease-out;
    transition-delay:0.1s;
  }
  &:focus {
    background-color: rgb(148, 12, 42);
  }
  &:disabled {
    background-color:grey;
  }
`

const BfButtonBlue = styled(BfButtonBlueNarrow)`        
        min-width: 150px;
`

const BfButtonBlueSecondary = styled(BfButtonBlueNarrowSecondary)`
        min-width: 150px;
` 

const DeactivateButton = styled(DeactivateButtonNarrow)`        
        min-width: 150px;
`

const BfButtonBlueSquare = styled(BfButtonSquare)`        
        width: 100px;
        height: 100px;
`

const BfButtonLink = styled(Button)`        
        font-family: "RM Neue", "sans-serif";
        font-size: 20px; 
        border-radius: 0.5em;           
`

const BfSelect = styled.select`        
    font-family: "RM Neue", "sans-serif";
    font-size: 20px;    
        
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #dee2e6;
    border-radius: 0.5em;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out; 
    &&:focus { 
        outline: none !important;
        border-color: #B7D2FB;
        border: 1px solid #B7D2FB;
        border-radius: 0.5em;;
        //box-shadow: 0 0 10px #719ECE;
    }   
    &&:disabled {
        background-color: #e9ecef;
        color: black;
  }
`

const BfButtonBlueToggle = styled(BfButtonBlueNarrow)`
        background-color: ${props => props.isActive ? colorConfig.button_focused : colorConfig.button_bg};
        color: black;

        :hover {
            background-color: ${colorConfig.button_focused};
            color: black !important;
        }
        :focus {
            background-color: ${colorConfig.button_focused};
            color: black;
        }
        :disabled {
            background-color: gray;
            color: black;
        }
`

const BfCheckboxContainer = styled.label`
    position: relative;
    align-items: center;
    cursor: pointer;

    .tooltip-text {
        visibility: hidden;
        font-size: 15px;
        width: 130px;
        background-color: #333;
        color: #fff;
        text-align: center;
        padding: 5px;
        border-radius: 5px;
        position: absolute;
        z-index: 1;
        bottom: 150%;
        left: 50%;
        transform: translateX(-50%);
        opacity: 0;
        transition: opacity 1.0s;
    }

    &:hover .tooltip-text {
        visibility: visible;
        opacity: 1;
    }
`;

const BfCheckboxContainer2 = styled.label`
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
`;

const BfCheckboxInput = styled.input.attrs({ type: 'checkbox' })`
    width: 20px;
    height: 20px;
    appearance: none;
    background-color: white;
    border: 2px solid #ccc;
    border-radius: 4px !important;
    position: relative;
    cursor: pointer;
    outline: none;

    &:checked {
        background-color: #044F67;
        border-color: #044F67;
    }
    
    &:checked::after {
        content: '\\2713'; /* Unicode checkmark */
        font-size: 16px;
        color: white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    :disabled {
        background-color: #9a9a9a;
    }
`;

const BfCheckboxInput2 = styled.input.attrs({ type: 'checkbox' })`
    width: 20px;
    height: 20px;
    appearance: none;
    background-color: white;
    border: 2px solid #ccc;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    outline: none;
    margin-right: 8px;
    margin-bottom: 6px;
    vertical-align: middle;

    &:checked {
        background-color: #044F67;
        border-color: #044F67;
    }

    &:checked::after {
        content: '\\2713'; /* Unicode checkmark */
        font-size: 14px;
        color: white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

const BfCheckboxText = styled.span`
    font-size: 1.25rem;
    font-family: "RM Neue", "sans-serif";
`;


const BfCheckboxLabel = styled.span`
    font-size: 1.5em;
    margin-left: 10px;
`

const BfYellowRowFormScore = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px; 
  margin-bottom: 10px;  
  color: black;
  padding: 10px 30px 0px 0;   
  font-family: "RM Neue", "sans-serif";
  font-size: 20px !important; 
  margin: 0 30px 10px 30px;
  border-radius: 10px;
`

const RatingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 20px; 
`

const BfYellowRowTerms = styled.div`
  margin: 0 30px 10px 30px;
  color: black;
  font-family: "RM Neue", "sans-serif";
  font-size: 20px !important; 
  border-radius: 10px;
  border: 1px solid #000000;
  padding-bottom: 20px;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  padding-bottom: 35px;
`

const RatingBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  color: ${colorConfig.tabellrad_tekst} !important;
  border-radius: 10px;
  border: 1px solid #FFFFFF;
  font-size: 30px;
  height: ${({ height }) => height};
  width: ${({ height }) => height};
`;

const RatingForm = styled.div`
  display: flex;
  justify-content: left;
  align-items: ${({ twoLines }) => twoLines ? '' : 'center'};
  padding: ${({ twoLines }) => twoLines ? '8px 10px 8px 10px' : '0 10px 0 10px'};
  background-color: white;
  color: ${colorConfig.tabellrad_tekst} !important;
  border-radius: 10px;
  border: 1px solid #FFFFFF;
  position: relative;
  top: ${({ twoLines }) => twoLines ? '13%' : '30%'};
  font-weight: 400;
  height: ${({ height }) => height};
  width: ${({ width }) => width};

  input {   
        padding: 20;
        font-family: "RM Neue", "sans-serif";
        font-size: 20px !important; 
        border-radius: 0.5em;
        border: 0px solid black;  

        *:focus {
           outline: none; !important; 
        }
    }

    .form-control {
        border-radius: 0.5em; !important; 
    }

    .form-control:focus {
        border-color: inherit;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 0.5em;
    }
`;

const LesButton = styled.button`
    color: black;
    background-color: ${colorConfig.button_bg};
    border-color: #1e6091;
    border-radius: 0.5em;
    border:none;
    font-family: "RM Neue", "sans-serif";
    font-size: 18px;
    padding: 2px 10px 2px 10px; 

    :focus {
        border: 1px;
    }

    :hover {
            background-color: ${colorConfig.button_focused};
            color: white;
            -webkit-transition: background-color 1.5s ease-out;
            -moz-transition: background-color 1.5s ease-out;
            -o-transition: background-color 1.5s ease-out;
            transition: background-color 1.5s ease-out;
            transition-delay:0.1s;
        }
`;

const SvarButton = styled.button`
    color: black;
    background-color: ${colorConfig.button_bg};
    border-color: #1e6091;
    border-radius: 0.5em;
    border:none;
    font-family: "RM Neue", "sans-serif";
    font-size: 18px;
    padding: 2px 10px 2px 10px; 

    :focus {
        border: 1px;
    }

    :hover {
            background-color: ${colorConfig.button_focused};
            color: white;
            -webkit-transition: background-color 1.5s ease-out;
            -moz-transition: background-color 1.5s ease-out;
            -o-transition: background-color 1.5s ease-out;
            transition: background-color 1.5s ease-out;
            transition-delay:0.1s;
        }
`;

const TableBadge = styled.span`
    display: inline-block;
    border-radius: 50%;
    text-align: center;
    width: 23px;
    height: 23px;
    border: 1px solid #0d6efd;
    font-size: 15px;
    color: navy;
`;

const ContainerButton = styled.div `
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 8px;
`;
      
const ButtonGroup = styled.div `
        display: flex;
        gap: 8px; /* Space between buttons */
`;

const ArticleAreaNySak = styled.div`
  margin-bottom: 2rem;
  margin-top: 0;
  font-size: 25px;
  font-weight: 300;
  line-height: 33.6px;
  margin-bottom: 0px;
  font-family: "RM Neue", "sans-serif";
  color: #333;
  
  h1 {
    font-size: 1.5em;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  p {
    font-size: 0.9em;
    margin-bottom: 1rem;
  }
  
  ul {
    font-size: 0.9em;
    margin: 0;
    padding-left: 1rem;
    list-style: disc;
  }
`;

const Circle = styled.button`    
    background: ${props => props.primary || "white"};
    width: 23px;
    height: 23px;
    border-radius: 50%;
    border: 1px solid black;
`;

const Heading = styled.h3`
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: 600;
  font-family: "RM Neue", "sans-serif";    
  `;

  const FieldLabel = styled.label`
  display: block;
  font-weight: 400;
`;

const FormRow = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  min-width: 140%;
`;

const FormColumn = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 60px;
`;

const RowsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    padding: 16px 0 40px 10px;
`;

const CollapsibleIcon = styled.button`
    position: relative;
    display: inline-block;
    cursor: pointer;
    outline: none;
    border: 0;
    text-decoration: none;
    background: transparent;
    padding: 0;
    font-size: inherit;
    font-family: "RM Neue", "sans-serif";
    width: 2rem;
    height: auto;

    .icon {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 1rem;
        height: 0.125rem;
        background: transparent;
        transition: transform 0.45s cubic-bezier(0.65, 0, 0.076, 1), 
                    background-color 0.45s ease;

        transform: ${({ isCollapsed, isHovered }) => {
            const baseRotation = isCollapsed ? 'rotate(90deg)' : 'rotate(-90deg)';
            const hoverTranslation = isHovered ? 'translate(0.3rem, 0)' : 'translate(0, 0)';
            return `${baseRotation} ${hoverTranslation}`;
        }};
    }

    .icon.arrow::before,
    .icon.arrow::after {
        content: "";
        position: absolute;
        width: 0.625rem;
        height: 0.170rem;
        background: #000;

        transition: transform 0.45s cubic-bezier(0.65, 0, 0.076, 1),
                    background-color 0.45s ease;
    }

    .icon.arrow::before {
        top: -0.25rem;
        right: 0;
        transform: ${({ isCollapsed }) =>
            isCollapsed ? 'rotate(45deg)' : 'rotate(-135deg)'};
    }

    .icon.arrow::after {
        bottom: -0.25rem;
        right: 0;
        transform: ${({ isCollapsed }) =>
            isCollapsed ? 'rotate(-45deg)' : 'rotate(135deg)'};
    }

    ${({ isHovered }) =>
        isHovered &&
        `
        .icon.arrow::before,
        .icon.arrow::after {
            background: #555;
        }
        .icon {
            background: #000;
        }
    `}
`;

const TableRowWithIcon = styled.tr`
    cursor: pointer;
    position: relative;
    transition: background-color 0.3s ease;

    .icon {
        position: absolute;
        left: 1rem;
        top: 50%;
        transform: translateY(-50%);
        width: 1rem;
        height: 0.125rem;
        background: transparent;
        transition: transform 0.45s cubic-bezier(0.65, 0, 0.076, 1), 
                    background-color 0.45s ease;

        transform: ${({ isCollapsed, isHovered }) => {
            const baseRotation = isCollapsed ? 'rotate(90deg)' : 'rotate(-90deg)';
            const hoverTranslation = isHovered ? 'translate(0.3rem, 0)' : 'translate(0, 0)';
            return `${baseRotation} ${hoverTranslation}`;
        }};
    }

    .icon.arrow::before,
    .icon.arrow::after {
        content: "";
        position: absolute;
        width: 0.625rem;
        height: 0.170rem;
        background: #000;
        transition: transform 0.45s cubic-bezier(0.65, 0, 0.076, 1),
                    background-color 0.45s ease;
    }

    .icon.arrow::before {
        top: -0.25rem;
        right: 0;
        transform: ${({ isCollapsed }) =>
            isCollapsed ? 'rotate(45deg)' : 'rotate(-135deg)'};
    }

    .icon.arrow::after {
        bottom: -0.25rem;
        right: 0;
        transform: ${({ isCollapsed }) =>
            isCollapsed ? 'rotate(-45deg)' : 'rotate(135deg)'};
    }

    &:hover .icon.arrow::before,
    &:hover .icon.arrow::after {
        background: #555;
    }

    &:hover .icon {
    transform: ${({ isCollapsed }) =>
      isCollapsed ? 'rotate(90deg) translate(0.2rem, 0)' : 'rotate(-90deg) translate(0.3rem, 0)'};
        background: #000;
    }
`;

const SearchHistoryLabel = styled.span`
    font-size: 16px;
    font-weight: bold;
    color: #333;
`;

const SearchHistoryValue = styled.span`
    font-size: 18px;
    font-weight: normal;
    color: #555;
`;

const LabelValueContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 4px;
`;

const CollapsibleContent = styled.div`
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  max-height: ${({ height }) => height}px;
`;

const ExpandableContent = styled.div`
    height: ${({ $isexpanded, height }) => ($isexpanded ? `${height}px` : '0px')};
    overflow: hidden;
    opacity: ${({ $isexpanded }) => ($isexpanded ? 1 : 0)};
    transition: height 0.6s ease-in-out, opacity 0.4s ease-in-out;
    background-color: inherit;
`;

const StyledRadio = styled.input.attrs({ type: 'radio' })`
  transform: scale(1.5);
  margin: 5px;
  accent-color: #044F67;
`;

const StyledSelect = styled.select`
font-size: 20px;
padding: 8px;
border-radius: 10px;
border: 1px solid #ccc;
color: #000;
`;

export { BfYellowRowForm, BfRowForm, BfTightRowForm, BfTightYellowRowForm, BfRowSpacer, BfFormLabel, BfFormLabelSm, BfFormErrorSm, BfFormControl, BfFormCheck, BfButtonBlue, BfButtonBlueSquare, BfButtonBlueSecondary, DeactivateButton, BfButtonBlueNarrow, BfButtonBlueToggle, BfButtonLink, BfSelect, BlueRow, YellowRoundedContainer, BfCheckboxContainer, BfCheckboxContainer2, BfCheckboxInput, BfCheckboxInput2, BfCheckboxLabel, BfCheckboxText, BfYellowRowFormScore, RatingContainer, BfYellowRowTerms, ButtonContainer, RatingBox, RatingForm, SvarButton, LesButton, TableBadge, ContainerButton, ButtonGroup, Circle, Heading, FieldLabel, FormRow, FormColumn, RowsWrapper, CollapsibleIcon, TableRowWithIcon, SearchHistoryLabel, SearchHistoryValue, CollapsibleContent, ExpandableContent, LabelValueContainer, StyledRadio, StyledSelect, ArticleAreaNySak }
